<div class="relative h-[60px] w-full overflow-hidden">
  <img
    src="https://superlikers-themes.s3.us-east-1.amazonaws.com/tonicorp/register.webp"
    alt="icon_register"
    class="absolute inset-0 h-full w-full object-cover" />
  <div
    class="absolute inset-0"
    style="background: linear-gradient(90deg, rgba(32, 42, 56, 0.6) 0%, rgba(1, 14, 21, 0.6) 100%)"></div>
  <div class="absolute inset-0 flex items-center justify-center">
    <div class="flex items-center">
      <img
        [src]="image()"
        class="size-10 object-contain"
        alt="image" />
      <p class="font-barlow text-blue-cyan-light ml-2 text-sm leading-5 font-bold tracking-[0%] text-wrap break-words">
        Objetivo:
        <span class="text-white">{{ text() }}</span>
      </p>
    </div>
  </div>
</div>
